export function getPinIconWithColor(fillColor) {
  // Path is taken from @material-ui/icons/Place.js
  return {
    anchor: { x: 8, y: 22 },
    path:
      'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
    scale: 1.5,
    fillColor,
    fillOpacity: 0.66,
  };
}

export function getStarIconWithColor(fillColor) {
  // Path is taken from @material-ui/icons/Stars.js
  return {
    anchor: { x: 8, y: 22 },
    path:
      'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z',
    scale: 1.5,
    fillColor,
    fillOpacity: 0.66,
  };
}

export const SERVICE_VEHICLE_TO_COLOR = {
  LEB001M: '#FF0000',
  MHT002M: '#00FF00',
  BOS004M: '#0000FF',
  PVD005M: '#FF00FF',
  DFW008M: '#FFFF00',
};

export function getIconFromServiceVehicle(serviceVehicleId, numBookings = 0) {
  const color = SERVICE_VEHICLE_TO_COLOR[serviceVehicleId] || '#ffffff';
  if (numBookings > 0) {
    return getStarIconWithColor(color);
  }
  return getPinIconWithColor(color);
}
